import { Component, OnInit, Renderer2, Inject, OnDestroy } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs';

@Component({
  selector: 'app-organized-portal',
  imports: [CommonModule],
  standalone: true,
  templateUrl: './organized-portal.component.html',
  styleUrl: './organized-portal.component.scss'
})
export class OrganizedPortalComponent implements OnInit, OnDestroy {
  private jsonLdScript: any;
  constructor(private router: Router, private activatedRoute: ActivatedRoute,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private _document: Document
  ) { }
  nav(url: any) {
    console.log(url);
    this.router.navigateByUrl(url)
  }
  ngOnInit(): void {
    this.injectSchemaMarkup();
    this.router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map((route) => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      filter((route) => route.outlet === 'primary'),
      mergeMap((route: { data: any; }) => route.data)
    )
  }
  ngOnDestroy(): void {
    this.removeSchemaMarkup();
  }
  injectSchemaMarkup(): void {
    const ecommerceCaseStudySchema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://www.kalpitatechnologies.com/kalpita-case-studies/organized-portal",
          "url": "https://www.kalpitatechnologies.com/kalpita-case-studies/organized-portal",
          "name": "Organized eCommerce Portal with Role-Based Access & Payment Gateways | Kalpita Case Study",
          "description": "Kalpita Technologies developed an online retail eCommerce platform for a Chilean company with three roles of managed access and payment gateway integration.",
          "isPartOf": { "@id": "https://www.kalpitatechnologies.com/#website" },
          "inLanguage": "en",
          "datePublished": "2024-01-15"
        },
        {
          "@type": "BreadcrumbList",
          "@id": "https://www.kalpitatechnologies.com/kalpita-case-studies/organized-portal#breadcrumb",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "item": { "@type": "WebPage", "@id": "https://www.kalpitatechnologies.com/", "name": "Home" } },
            { "@type": "ListItem", "position": 2, "item": { "@type": "WebPage", "@id": "https://www.kalpitatechnologies.com/kalpita-case-studies/case-study", "name": "Case Studies" } },
            { "@type": "ListItem", "position": 3, "item": { "@type": "WebPage", "@id": "https://www.kalpitatechnologies.com/kalpita-case-studies/organized-portal", "name": "Organized eCommerce Portal" } }
          ]
        },
        {
          "@type": "Article",
          "headline": "Organized eCommerce Portal with 3 Roles of Managed Access and Payment Gateways",
          "articleBody": "Kalpita Technologies' in-house team developed an online retail eCommerce platform for a Chilean company, providing three levels of access: Admin, Seller, and Customer...",
          "author": { "@type": "Organization", "name": "Kalpita Technologies" },
          "publisher": {
            "@type": "Organization",
            "name": "Kalpita Technologies",
            "logo": { "@type": "ImageObject", "url": "https://www.kalpitatechnologies.com/assets/common/black-logo.png" }
          },
          "datePublished": "2024-01-15",
          "image": "https://www.kalpitatechnologies.com/assets/industry/casestudies/organized-computerEcommerce.png"
        },
        {
          "@type": "HowTo",
          "name": "How to Build a Multi-Country eCommerce Platform with Role-Based Access",
          "step": [
            { "@type": "HowToStep", "name": "Define Access Roles", "text": "Establish Admin, Seller, and Customer roles with specific permissions." },
            { "@type": "HowToStep", "name": "Integrate Payment Gateway", "text": "Implement secure transaction processing through F-Pay integration." },
            { "@type": "HowToStep", "name": "Multi-Country Logic", "text": "Build in-app location switching for localized products and offers." }
          ]
        },
        {
          "@type": "FAQPage",
          "@id": "https://www.kalpitatechnologies.com/kalpita-case-studies/organized-portal#faq",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What are the three access roles in the eCommerce portal?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "The platform provides managed access for Admin, Seller, and Customer roles, each tailored to specific responsibilities."
              }
            }
          ]
        },
        {
          "@type": "Organization",
          "@id": "https://www.kalpitatechnologies.com/#organization",
          "name": "Kalpita Technologies",
          "url": "https://www.kalpitatechnologies.com/",
          "logo": { "@type": "ImageObject", "url": "https://www.kalpitatechnologies.com/assets/common/black-logo.png" }
        }
      ]
    };

    this.jsonLdScript = this.renderer.createElement('script');
    this.jsonLdScript.type = 'application/ld+json';
    this.jsonLdScript.text = JSON.stringify(ecommerceCaseStudySchema);
    this.renderer.appendChild(this._document.head, this.jsonLdScript);
  }

  removeSchemaMarkup(): void {
    if (this.jsonLdScript) {
      this.renderer.removeChild(this._document.head, this.jsonLdScript);
      this.jsonLdScript = null;
    }
  }
}
